<template>
  <div class="request-progress-bar" :class="{ 'request-progress-bar--full' : completed, 'request-progress-bar--empty' : empty }">
    <div class="request-progress-bar__inner" :style="progress"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentBatch: null,
      totalBatches: null,
    }
  },
  computed: {
    utilityPlan() {
      return this.$store.getters.utilityPlan.slug
    },
    pricingRequestStatus() {
      return this.$store.getters.pricingRequestStatus
    },
    batchDatesRemaining() {
      return this.$store.getters.batchDatesRemaining
    },
    batchDatesTotal() {
      return this.$store.getters.batchDatesTotal
    },
    percentLoaded() {
      if (this.batchDatesTotal === 0 && this.batchDatesRemaining === 0) {
        return 0
      }

      return Math.round(((this.batchDatesTotal - this.batchDatesRemaining) / this.batchDatesTotal) * 100)
    },
    progress() {
      return 'width: ' + this.percentLoaded + '%'
    },
    empty() {
      return this.percentLoaded === 0
    },
    completed() {
     return this.percentLoaded > 98
    }
  }
}
</script>